import { useContext } from 'react';

import type { TruncationMode } from '../../../typography/text-ellipsis/TextEllipsis.js';
import { HoneycombTruncationMode } from '../context/honeycomb-truncation-mode.context.js';

export const useHoneycombTruncationMode = () =>
  useContext<TruncationMode>(HoneycombTruncationMode);
